(function () {
	'use strict';

	var projectSummaryDisplayMapping = {
		'target-totalSavings': {'column': 'targetSavings', 'filterValue': 'Target Total Savings'},
		'actual-totalSavings': {'column': 'actualSavings', 'filterValue': 'Actual Total Savings'},
		'target-weightedSavings': { 'column': 'targetWeightedSavings', 'filterValue': 'Weighted Target Savings' },
		'numberOfProjects': {'column': 'numberOfProjects', 'format': 'number', 'label': 'Projects'},
		'percentComplete': {'column': 'percentComplete', 'format': 'percent', 'label': '% Complete'}
	};

	angular.module('app.dashboard')
		.controller('leanProjectSummary', leanProjectSummary)
		.directive('leanProjectSummaryWidget', leanProjectSummaryDirective);

	function leanProjectSummary($rootScope, $scope, $timeout, $translate, config, optionBlocks, dashboardFilterInitializationService,
			currencyFormatService, percentageFormatService, leanProjectSummaryService, pageTimingService, siteService,
			leanFilterService, storeService) {
		$scope.displayOptions = [
			{'name': $translate.instant('Target Total Savings'), 'id': 'target-totalSavings', 'access': 'All'},
			{'name': $translate.instant('Actual Total Savings'), 'id': 'actual-totalSavings', 'access': 'All'},
			{'name': $translate.instant('Weighted Target Savings'), 'id': 'target-weightedSavings', 'access': 'All' },
			{'name': $translate.instant('Number of Projects'), 'id': 'numberOfProjects', 'access': 'All'},
			{'name': $translate.instant('% Complete'), 'id': 'percentComplete', 'access': 'All'},
			{'name': 'None', 'id': 'none', 'access': 'All'}
		];

		var configStr;
		$scope.modelDetails = $scope.$parent.model;
		if (!config.optionBlocks) {
			configStr = $scope.modelDetails.configStr ? JSON.parse($scope.modelDetails.configStr) : {};
		} else {
			configStr = config;
		}

		optionBlocks = configStr['optionBlocks'];
		setBlocks(optionBlocks);
		$scope.savingsSelect = !optionBlocks;
		$scope.firstTime = !optionBlocks;
		$scope.lastBlocks = _.cloneDeep(optionBlocks);
		$scope.block1 = '-';
		$scope.block2 = '-';
		$scope.block3 = '-';
		$scope.block4 = '-';
		$scope.queryString = '';
		$scope.$parent.$parent.hidePencil = true;
		$scope.getLabel = getLabel;
		$scope.getHyperLink = getHyperLink;
		$scope.getDisplayOptions = getDisplayOptions;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;

		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.savingsSelect = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		$scope.closeDialog = function() {
			$scope.savingsSelect = false;
			$scope.$parent.$parent.hidePencil = false;
		};

		$scope.saveSavings = function () {
			var isBlockChanged = isBlockOptionsChanged();
			if (isBlockChanged) {
				$scope.savingsSelect = false;
				$scope.firstTime = false;
				updateConfig();
				loadData();
			} else {
				$scope.savingsSelect = false;
				$scope.$parent.$parent.hidePencil = false;
			}
		};

		function getDisplayOptions() {
			return _.filter($scope.displayOptions, function (o) { return o.access === 'All'; });
		}

		function getLabel(blockIndex) {
			var selectedOption = $scope.blocks[blockIndex].id;
			if (selectedOption === 'none') {
				return '&nbsp;';
			} else if (!projectSummaryDisplayMapping[selectedOption].label) {
				return projectSummaryDisplayMapping[selectedOption].filterValue;
			}
			return projectSummaryDisplayMapping[selectedOption].label;
		}

		function getHyperLink(blockIndex) {
			var selectedOption = $scope.blocks[blockIndex].id;
			var url = '/application/f/home.html#/lean-projects/projects-kanban/?';
			if (selectedOption === 'none') {
				return '';
			} else if (!projectSummaryDisplayMapping[selectedOption].filterValue) {
				return url + $scope.queryString;
			}
			return url + $scope.queryString + '&projectSavings=' + projectSummaryDisplayMapping[selectedOption].filterValue;
		}

		function updateConfig() {
			cleanUpBlocks();
			var model = $scope.$parent.model;
			model.config.optionBlocks = $scope.blocks;
			$scope.lastBlocks = _.cloneDeep($scope.blocks);
			pendo.track('widgetChangeConfig', {
				widgetType: model.config.type,
				display0: model.config.optionBlocks[0].id,
				display1: model.config.optionBlocks[1].id,
				display2: model.config.optionBlocks[2].id,
				display3: model.config.optionBlocks[3].id
			});
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(model),
					widget: {
						name: model.config.type,
						config: _.cloneDeep(model.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
		}

		function setBlocks(blocks) {
			if (!blocks) {
				$scope.blocks = {
					0 : {'id':'target-totalSavings'},
					1 : {'id':'actual-totalSavings'},
					2 : {'id':'numberOfProjects'},
					3 : {'id':'percentComplete'}
				};
			} else {
				$scope.blocks = blocks;
			}

			if (blocks) {
				$scope.lastBlocks = _.cloneDeep($scope.blocks);
			}
		}

		function cleanUpBlocks() {
			_.forEach($scope.blocks, function(value, key) {
				delete value.name;
				delete value.access;
			});
		}

		function isBlockOptionsChanged() {
			var optionsChanged = false;
			if (!$scope.lastBlocks && $scope.blocks) {
				return true;
			}

			angular.forEach($scope.blocks, function(value, key) {
				if ($scope.lastBlocks[key].id !== value.id) {
					optionsChanged = true;
				}
			});
			return optionsChanged;
		}

		function setBlockValue(blockIndex, data, targetCurrency) {
			var selectedOption = $scope.blocks[blockIndex].id;
			if (selectedOption === 'none') {
				return 'none';
			} else {
				var unformatedData = data[projectSummaryDisplayMapping[selectedOption].column];
				var formattedData = '';
				if (!projectSummaryDisplayMapping[selectedOption].format) {
					formattedData = currencyFormatService.get(unformatedData, targetCurrency);
				} else if (projectSummaryDisplayMapping[selectedOption].format === 'percent'){
					formattedData = percentageFormatService.getWithParameters(unformatedData, 0);
				} else {
					formattedData = unformatedData;
				}
				return formattedData;
			}
		}

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'leanProjectFilterChanged']);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				if (!$scope.savingsSelect) {
					leanProjectSummaryService.getSummaryData(leanFilterService).then(function (response) {
						$scope.queryString = getQueryParams();
						if (response.data.targetSavings || response.data.targetSavings === 0) {
							var data = response.data;
							$scope.block1 = setBlockValue(0, data, response.targetCurrency);
							$scope.block2 = setBlockValue(1, data, response.targetCurrency);
							$scope.block3 = setBlockValue(2, data, response.targetCurrency);
							$scope.block4 = setBlockValue(3, data, response.targetCurrency);
						}
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						$scope.$parent.$parent.hidePencil = false;
					});
				}
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();

		function getQueryParams() {
			var queryParams = 'drilldown=1&';
			var timePeriod = (!dashboardFilterInitializationService.getSelected('Time Period') ? 'current':
				dashboardFilterInitializationService.getSelected('Time Period'));

			queryParams += leanFilterService.getTimePeriodFilterQueryParam('timePeriod', timePeriod);
			if (dashboardFilterInitializationService.getSelected('Lean Project Area')) {
				queryParams += '&projectArea=' + encodeURIComponent(dashboardFilterInitializationService.getSelected('Lean Project Area'));
			}
			if (dashboardFilterInitializationService.getSelected('Lean Project Stage')) {
				queryParams += '&stageId=' + dashboardFilterInitializationService.getSelected('Lean Project Stage');
			} else {
				var archivedStageIds = leanProjectSummaryService.getArchiveStageIds(dashboardFilterInitializationService.getObjectList('Lean Project Stage'));
				if (archivedStageIds.length > 0) {
					queryParams += '&stageId=' + archivedStageIds;
				}
			}
			if (dashboardFilterInitializationService.getSelected('Business Unit')) {
				queryParams += '&businessunit=' + encodeURIComponent(dashboardFilterInitializationService.getSelected('Business Unit'));
			}
			if (dashboardFilterInitializationService.getSelected('Lean Project Manager')) {
				queryParams += '&projectManagerId=' + dashboardFilterInitializationService.getSelected('Lean Project Manager');
			}
			if (dashboardFilterInitializationService.getSelected('Lean Project Type')) {
				queryParams += '&projectType=' + encodeURIComponent(dashboardFilterInitializationService.getSelected('Lean Project Type'));
			}
			if (dashboardFilterInitializationService.getSelected('Lean Project Category')) {
				queryParams += '&projectCategoryId=' + dashboardFilterInitializationService.getSelected('Lean Project Category');
			}
			if (dashboardFilterInitializationService.getSelected('Lean Project Goals')) {
				queryParams += '&projectGoalId=' + dashboardFilterInitializationService.getSelected('Lean Project Goals');
			}
			if (dashboardFilterInitializationService.getSelected('Factory')) {
				queryParams += '&factory=' + dashboardFilterInitializationService.getSelected('Factory');
			}
			if (dashboardFilterInitializationService.getSelected('ProjectSavingsCategories')) {
				queryParams += '&projectSavingsCategoryId=' + dashboardFilterInitializationService.getSelected('ProjectSavingsCategories');
			}
			var filterQueryParam = getFilterQueryParam();
			if (filterQueryParam) {
				queryParams += '&filter=' + filterQueryParam;
			}
			return queryParams;
		}

		function getFilterQueryParam() {
			var queryParamsObj =  leanFilterService.getQueryParamsObject();
			return queryParamsObj.filter;
		}
	}

	function leanProjectSummaryDirective($compile, $window) {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var w = angular.element($window);
				elem[0].id = elem[0].id + scope.$id;
				var elementId = elem[0].id;

				scope.getWindowDimensions2 = function () {
					return {
						'w': jQuery('#' + elem.attr('id')).width(),
						'h': window.innerHeight
					};
				};

				scope.$watch(scope.getWindowDimensions2, function (newValue, oldValue) {
					if (newValue.w < 200) {
						jQuery('#' + elem.attr('id')).removeClass('small medium large').addClass('verysmall');
					} else if (newValue.w < 390) {
						jQuery('#' + elem.attr('id')).removeClass('verysmall medium large').addClass('small');
					} else if (newValue.w < 500) {
						jQuery('#' + elem.attr('id')).removeClass('verysmall small large').addClass('medium');
					} else {
						jQuery('#' + elem.attr('id')).removeClass('verysmall small medium').addClass('large');
					}
				}, true);


				w.bind('resize', function () {
					scope.$apply();
				});
			}
		};
	}
})();
